import { Dispatch } from 'react';
import { composeGetQuery } from '../../../api/utils';
import { listApiConfig } from '../../../constants/guidedQuoting';
import { renderItemContentForItemsWithIdName } from '../../../routes/Settings/rules-v3/rules.utils';
import { MCustomMultiSelect } from '../MCustomSelect/MCustomMultiSelect';

interface SelectProps {
  filters: any;
  value: any;
  setValue: Dispatch<any>;
}

const ProductDropdownMultiSelect = ({
  filters,
  value,
  setValue,
}: SelectProps) => {
  return (
    <MCustomMultiSelect
      showQueryInput
      returnItem={true}
      closeButtonText="Apply"
      endpoint="/api/products"
      additionalSearchParams={composeGetQuery(listApiConfig, filters)}
      getByIdEndpointFn={(record: any) => `/api/products/${record.id}`}
      itemTitle="name"
      itemValue="id"
      renderItemContent={renderItemContentForItemsWithIdName}
      value={value ?? []}
      onChange={(newValue: any) => setValue(newValue)}
      isLazy
      multiple
      inputProps={{
        _placeholder: { color: 'tPurple.dark' },
        _disabled: {
          _placeholder: {
            color: 'tGray.darkPurple',
          },
        },
      }}
    />
  );
};

export default ProductDropdownMultiSelect;
